import PropTypes, { arrayOf } from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Message } from "semantic-ui-react";
import { findSubSections, makeSectionPath } from "shared/selectors/unit";
import { groupBy, sortBy, min } from "lodash";
import { FormattedMessage } from "react-intl";
import CardGrid from "../cardGrid/CardGrid";
import { navigationButton } from "../../helpers/navigationButton";
import "./sectionMenu.scss";
import { SectionGroupShape } from "../../shapes/sectionGroup.shape";
import { withRouter } from "../../helpers/withRouter";

class SectionMenu extends React.Component {
  renderSectionGroups() {
    const { sectionGroups } = this.props;

    return (
      <div data-component="sectionMenu">
        {sectionGroups.map(this.renderSectionGroup)}
      </div>
    );
  }

  renderSectionGroup = group => {
    const { makeSectionPath } = this.props;
    const items = group.sections.map(section => {
      return {
        key: `${section.id}`,
        title: section.title,
        imageUrl: section.image,
        imageClass: section.imageClass,
        url: makeSectionPath(section.id),
        total: section.total,
        isPriceOnRequest: section.isPriceOnRequest,
        isMandatoryDisplay: section.isMandatoryDisplay,
        button: navigationButton(section)
      };
    });

    return (
      <div
        key={group.title}
        data-component="sectionGroup"
        style={{ marginBottom: "10px" }}
      >
        {group.showTitle && <h3>{group.title}</h3>}
        <CardGrid items={items} />
      </div>
    );
  };

  render() {
    const { sectionGroups } = this.props;

    if (sectionGroups.length > 0) {
      return this.renderSectionGroups();
    }
    return (
      <Message
        className="margin top spacious"
        icon="meh"
        header={
          <FormattedMessage id="buyerPortal.messages.somethingWentWrong" />
        }
        content={
          <FormattedMessage id="buyerPortal.messages.missing_configuration" />
        }
      />
    );
  }
}

const mapStateToProps = (state, props) => {
  const { sectionId } = props.params;

  const subSections = findSubSections(state, sectionId).filter(subSection => {
    return subSection.isVisible && subSection.hasChildren;
  });

  const groupedSections = groupBy(subSections, "group");
  const sectionGroups = sortBy(
    Object.keys(groupedSections).map(title => {
      const sections = groupedSections[title] || [];
      const position = min(sections.map(s => s.position));
      return {
        title,
        sections,
        position,
        showTitle: Object.keys(groupedSections).length > 1
      };
    }),
    "position"
  );

  return {
    sectionGroups,
    makeSectionPath: id => makeSectionPath(props, id)
  };
};

SectionMenu.defaultProps = {
  sectionGroups: []
};

SectionMenu.propTypes = {
  sectionGroups: arrayOf(SectionGroupShape),
  makeSectionPath: PropTypes.func.isRequired
};

export default withRouter(connect(mapStateToProps)(SectionMenu));
